<template>
  <v-row align="center" justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span>
            Server list
          </span>
          <v-btn small color="primary" @click="dialogs.create.show = true">
            Create server
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :loading="loading"
            :headers="table.columns"
            :items="servers"
          >
            <template v-slot:item.action="{ item }">
              <v-btn icon @click="editServer(item)">
                <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
    <server-create-dialog
      :show.sync="dialogs.create.show"
      @create="fetchServers"
    >
    </server-create-dialog>
    <server-update-dialog
      :show.sync="dialogs.update.show"
      :id="dialogs.update.serverId"
      @update="fetchServers"
    >
    </server-update-dialog>
  </v-row>
</template>

<script>
import { fetchServers } from "../../../../api/server.api.js";
import ContentLoader from "../../../mixins/ContentLoader.js";
import ServerCreateDialog from "./ServerCreateDialog.vue";
import ServerUpdateDialog from "./ServerUpdateDialog.vue";

export default {
  name: "ServerIndex",
  components: {
    ServerUpdateDialog,
    ServerCreateDialog
  },
  mixins: [ContentLoader],
  data() {
    return {
      servers: [],
      dialogs: {
        create: {
          show: false
        },
        update: {
          show: false,
          serverId: null
        }
      },
      table: {
        columns: [
          {
            text: "Domain",
            value: "domain"
          },
          {
            text: "Style",
            value: "style"
          },
          {
            text: "Actions",
            value: "action"
          }
        ]
      }
    };
  },
  mounted() {
    this.fetchServers();
  },
  methods: {
    async fetchServers() {
      this.$startLoading();

      try {
        const response = await fetchServers();

        this.servers = response.data.servers;

        await this.$nextTick();
      } catch (e) {
        console.error(e);
      } finally {
        this.$finishedLoading();
      }
    },
    handleDelete(sortition) {
      this.sortitions.splice(this.sortitions.indexOf(sortition), 1);
    },
    async deleteSortition(item) {
      this.deleteDialog.sortition = item;
      await this.$nextTick();
      this.deleteDialog.show = true;
    },
    async editServer({ id }) {
      this.dialogs.update.serverId = id;
      await this.$nextTick();
      this.dialogs.update.show = true;
    }
  }
};
</script>

<style scoped></style>
